import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class RuntimeServerResolutionRule  {
    _originalTypeClassName = "zAppDevManager.BO.RuntimeServerResolutionRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
RuntimeServerResolutionRule.translate = translateService;
}
this.Id = null;
this.Enabled = false;
this.Score = null;
this.UserId = null;
this.ApplicationId = null;
this.SubscriptionId = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Enabled:any;
Score:any;
UserId:any;
ApplicationId:any;
SubscriptionId:any;
Description:any;
RuntimeServer:any;
Environment:any;
static setRuntimeServer = ($this, value) => {
var oldValue = $this.RuntimeServer;
$this.RuntimeServer = value;
if (value != null) {
}
}
static setEnvironment = ($this, value) => {
var oldValue = $this.Environment;
$this.Environment = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}